import { ArrowForwardIos, CallSplit, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#3b82f6' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
      }}>
        <CallSplit sx={{ width: "18px", height: "18px", color: "#06b6d4" }} />
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Randomizador
        </div>
      </div>

      <div style={{ color: "#6b7280", fontSize: "12px", marginBottom: '16px' }}>
        Divide o fluxo aleatoriamente
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative'
        }}>
          <div style={{ fontSize: "14px", color: "#111827", fontWeight: 500 }}>
            Caminho A: {data.percent}%
          </div>
          <Handle
            type="source"
            position="right"
            id="a"
            style={{
              background: "#3b82f6",
              width: "12px",
              height: "12px",
              right: "-6px",
              cursor: 'pointer',
              border: '2px solid white',
              position: 'absolute'
            }}
            isConnectable={isConnectable}
          />
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative'
        }}>
          <div style={{ fontSize: "14px", color: "#111827", fontWeight: 500 }}>
            Caminho B: {100 - data.percent}%
          </div>
          <Handle
            type="source"
            position="right"
            id="b"
            style={{
              background: "#3b82f6",
              width: "12px",
              height: "12px",
              right: "-6px",
              cursor: 'pointer',
              border: '2px solid white',
              position: 'absolute'
            }}
            isConnectable={isConnectable}
          />
        </div>
      </div>
    </div>
  );
});
